import { syncAction } from 'lib/action';
import { AgGridRefreshServerSidePayload, AgGridRefreshColumnDefsPayload } from 'domain/agGrid/types';

export const agGridRefreshServerSideAction = syncAction<AgGridRefreshServerSidePayload>('AG_GRID/REFRESH_SERVER_SIDE');
export const agGridRefreshColumnDefsAction = syncAction<AgGridRefreshColumnDefsPayload>('AG_GRID/REFRESH_COLUMN_DEFS');
